/* ADD GROUPS */
export const LIST_GROUP_PARTICIPANTS = "LIST_GROUP_PARTICIPANTS"
export const LIST_GROUP_PARTICIPANTS_SUCCESS = "LIST_GROUP_PARTICIPANTS_SUCCESS"
export const LIST_GROUP_PARTICIPANTS_CLEAN = "LIST_GROUP_PARTICIPANTS_CLEAN"
export const LIST_GROUP_PARTICIPANTS_ERROR = "LIST_GROUP_PARTICIPANT_ERROR"
